export class DisplayLabel {
  constructor(
    public id: number,
    public label: string,
  ) {}
}
